<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="create-test-topbar d-flex align-items-center flex-wrap py-15 px-20">
    <div class="left-col d-flex align-items-center max-w-[300px] me-20">
      <h3 class="me-20 mb-0">Create test</h3>
    </div>
    <div class="right-col d-flex align-items-center flex-grow-1 justify-content-end">
      <a tooltip="Clear all test settings" tooltipPlacement="top" class="rounded-icon mx-15" (click)="resetAllSelectedValues()"><span
          class="far fa-trash-alt"></span></a>
      <div class="inc-dec-box d-flex align-items-center bg-neutral-n1 px-10 me-10 py-0_7">
        <span tooltip="Issue the current test batch multiple times at once" tooltipPlacement="top" class="icon-refresh me-0_7 icon"></span>
        <input [(ngModel)]="model.testRepeatsPerIteration" formControlName="testRepeatsPerIteration" type="number" min="1" max="99" step="1"
          (ngModelChange)="calculateCountResults()" class="form-control inc-dec-input" />
      </div>
      <div class="button-group">
        <button *ngIf="showButtons" [disabled]="!valid || loading" type="submit" class="btn btn-primary px-20 py-0_7">
          Run
          <span *ngIf="countResults">({{ countResults }})</span>
        </button>
      </div>
    </div>
  </div>
  <div class="create-test-body">
    <div class="create-test-box-wrapper d-flex flex-wrap">
      <div class="create-test-box-holder description">
        <div class="create-test-box px-20 py-20">
          <app-mo-number-input [country]="country" [shortCodeCountries]="shortCodeCountries" [form]="form"
            (changeCount)="setNumbersCount($event)"></app-mo-number-input>
          <div class="form-group">
            <h4>Text</h4>
            <app-mo-text-input [form]="form" (changeCount)="setTextsCount($event)"></app-mo-text-input>
          </div>
        </div>
      </div>
      <div class="create-test-box-holder destinations">
        <div class="create-test-box px-20 py-20">
          <app-destinations-select [showManualAddNumbers]="!!user" [countryName]="country" [shortCodeCountries]="shortCodeCountries" [recent]="false"
            [source]="'mo'" (onChange)="onChangeDestinations()"></app-destinations-select>
        </div>
      </div>
    </div>
  </div>
</form>



<ng-template #confirmModalTpl let-dialogRef="dialogRef">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Test summary</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-usage-guidelines-banner></app-usage-guidelines-banner>

    <div class="d-flex modal-tabs-vertical">
      <ul class="nav flex-column">
        <div (click)="scrollTo('phone')">
          <a class="nav-link cp" [ngClass]="{ 'active': currentSection === 'phone' }">
            <span class="nav-text"> Phone</span>
          </a>
        </div>
        <div (click)="scrollTo('texts')">
          <a class="nav-link cp" [ngClass]="{ 'active': currentSection === 'texts' }">
            <span class="nav-text"> Texts</span>
          </a>
        </div>
        <div (click)="scrollTo('countries')">
          <a class="nav-link cp" [ngClass]="{ 'active': currentSection === 'countries' }">
            <span class="nav-text"> Countries</span>
          </a>
        </div>
      </ul>

      <div class="tab-content section-parent" id="parentDiv" scrollSpy [spiedTags]="['DIV']" (sectionChange)="onSectionChange($event)">
        <div id="phone" class="section-child">
          <ul class="modal-tab-list modal-tab-table-list">
            <li class="title">Phone</li>
            <li *ngFor="let sender of numberInput.getNumbers()">
              <span>{{sender}}</span>
            </li>
          </ul>
        </div>
        <div id="texts" class="section-child">
          <ul class="modal-tab-list modal-tab-table-list">
            <li class="title">Texts</li>
            <li *ngFor="let text of textInput.getTexts()">
              <span>{{ !text.text ? '(empty)' : text.text }}</span>
            </li>
          </ul>
        </div>
        <div id="countries" class="section-child">
          <ul class="modal-tab-list modal-tab-table-list">
            <li class="title">Countries</li>
            <li *ngFor="let country of countries.getSelectedModels()">
              <span *ngIf="!country.custom">{{country.countryName}}({{country.mcc}})/{{country.providerName}}({{country.mnc}}) </span>
              <span *ngIf="!country.custom && country.originalMnc">
                <= {{country.originalProviderName}}({{country.originalMnc}}) </span>
                  <span *ngIf="country.custom">{{country.phonenumber}} </span>
                  <span class="text-primary" *ngIf="model.testRepeatsPerIteration"> x {{ model.testRepeatsPerIteration }}</span>
            </li>
          </ul>
        </div>
        <!-- This below element is needed to have last section in focus when scrolling ... -->
        <div class="section-empty-child"></div>
      </div>
    </div>
  </div>

  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
      <div class="d-flex justify-content-end align-items-center">
        <h5 class="mb-0" [ngClass]="{'error-blink': this.testsPrice > 50}">{{ this.countResults }} <span>tests for</span> € {{ this.testsPrice }}</h5>
        <button class="btn btn-primary ms-15" (click)="dialogRef.close(true)">Confirm</button>
      </div>
    </div>
  </div>
</ng-template>
